import React, { FC, memo } from 'react';
import classNames from 'classnames';
import { SearchBox } from 'tea-component';

interface ISkillsSelectSearchRowProps {
  isEN?: boolean;
  value: string;
  onChange: (value: string) => void;
  /** 追加到 SearchBox 的 className（兼容旧 BEM） */
  inputClassName?: string;
}

/**
 * Skills 面板内搜索行（与 SkillsCollection 共用样式类）
 */
const SkillsSelectSearchRow: FC<ISkillsSelectSearchRowProps> = ({
  isEN = false,
  value,
  onChange,
  inputClassName,
}) => {
  return (
    <div className="dba-skills-select-search">
      <SearchBox
        simple
        className={classNames('dba-skills-select-search-input', inputClassName)}
        placeholder={isEN ? 'Search Skills' : '搜索技能'}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default memo(SkillsSelectSearchRow);
